export default function () {
  return function (items, selectedEmployees) {
    if (!selectedEmployees || selectedEmployees.length === 0) {
      return items;
    }

    if(selectedEmployees[0].userId !== undefined){
      return items.filter(item => {
        const userIdMatch = selectedEmployees.some(employee => item.employeeId === employee.userId);
        return userIdMatch;
      });
    }

    return items.filter(item => {
      const userIdMatch = selectedEmployees.some(employee => item.employeeId === employee.employeeId);
      return userIdMatch;
    });
  };
}



// WEBPACK FOOTER //
// ./client/app/common/filters/employee.filter.js